import { render } from "./IconRecycle.vue?vue&type=template&id=bd3328ee"
import script from "./IconRecycle.vue?vue&type=script&lang=ts"
export * from "./IconRecycle.vue?vue&type=script&lang=ts"
script.render = render

export default script